import React, { useEffect } from 'react';
import { OnboardingLayout } from 'layouts/OnboardingLayout';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import { OtpConfirmation } from './OtpConfirmation';
import { AuthConfirmation } from './AuthConfirmation';
import './style.scss';
import { useMetrics } from 'hooks/metrics/useMetrics';
import { UNUSED_PARAMETER } from 'hooks/metrics/shared/constants'

export const AppAuthConfirmModal = ({ isMobileAuth, userhash, userData = {} }) => {
  const { isMobile } = useVerifyIsMobile(1367);
  const isTouchDevice =
    'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const isMobileTouch = isMobile && isTouchDevice;
  const { buildMetricsEvent, sendMetricsEvent } = useMetrics();

  useEffect(() => {
    const event = buildMetricsEvent('email_linked', {
      user_id: userData?.user_id || UNUSED_PARAMETER,
      parent_id: userData?.parent_id || UNUSED_PARAMETER,
      user_id_custom: userData?.user_id || UNUSED_PARAMETER,
      user_type: 'registrado',
      content_section: 'inicio',
      modulo_name: 'todo listo! vuelve a tu tv y comienza a disfrutar claro video',
      interaction_type: 'descarga la app',
      method: 'mi telmex',
      authpn: 'amco',
      status_code: 'codigo exitoso',
    });

    sendMetricsEvent(event);
  }, []);

  return (
    <div className="AppAuthConfirmModal">
      <OnboardingLayout type="OTP" styles={{padding: "32px 4px"}}>
        <div className="AppAuthConfirmModal__Content">
          <div className="AppAuthConfirmModal__Content__Background" />
          {isMobileAuth && userhash ? (
            <AuthConfirmation isMobile={isTouchDevice} userhash={userhash} />
          ) : (
            <OtpConfirmation isMobile={isMobileTouch} />
          )}
        </div>
      </OnboardingLayout>
    </div>
  );
};
